module.exports = __webpack_public_path__ + "07ddcb8eaa25531fd1d9be03532af7cb.svg";